import React from 'react';
import { reduxForm } from 'redux-form';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import {
  Button, Login, Password, ErrorMessage, Recaptcha,
} from '@app/components';
import RouterConstants from '@app/constants/router';
import colors from '@app/constants/colors';
import { isRecaptchaShown } from '@app/helpers/recaptchaHelpers';

let LoginForm = ({
  handleSubmit, submitting, isRecaptchaShown, error,
}) => (
  <form onSubmit={handleSubmit}>
    <Login />
    <Password />
    { isRecaptchaShown && <Recaptcha /> }
    {
      error && (
        <ErrorMessage>
          <FormattedMessage id={`signIn.error.${get(error, 'code')}`} />
        </ErrorMessage>
      )
    }
    <StyledLink to={RouterConstants.FORGOT_PASSWORD}>
      <FormattedMessage id="signIn.forgotPassword" />
    </StyledLink>
    <Button
      type="submit"
      labelId="signIn.button"
      textColor={colors.ALICE_BLUE}
      backgroundColor={colors.INTERNATIONAL_ORANGE}
      disabled={submitting}
      loading={submitting}
    />
  </form>
);

LoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired, // This method is added by redux-form itself,
  submitting: PropTypes.bool.isRequired, // This method is added by redux-form itself,
  isRecaptchaShown: PropTypes.bool.isRequired,
  error: PropTypes.shape({
    code: PropTypes.number.isRequired,
    message: PropTypes.string,
  }),
};

LoginForm.defaultProps = {
  error: null,
};

const mapStateToProps = ({ user: { error, failedLoginAttemptsNumber } }) => ({
  error,
  isRecaptchaShown: isRecaptchaShown(failedLoginAttemptsNumber),
});

LoginForm = connect(mapStateToProps)(LoginForm);

export default reduxForm({
  form: 'login',
})(LoginForm);

const StyledLink = styled(Link)`
  text-decoration: underline;
  margin: 20px 0 30px;
  color: white;
  display: block;
`;
